// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentLeft_wrapper__1u2N4"};